export interface IAddToCartNotification extends HTMLElement {
  showNotification(): void;
}

class AddToCartNotification
  extends HTMLElement
  implements IAddToCartNotification
{
  constructor() {
    super();
  }

  public showNotification(): void {
    this.classList.add("is-active");
    setTimeout(() => {
      this.hideNotification();
    }, 3000);
  }

  private hideNotification(): void {
    this.classList.remove("is-active");
  }
}

customElements.define("uwp-add-to-cart-notification", AddToCartNotification);
